module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7GvSO"))).then(() => module.bundle.root('37nVf'));